import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{yield this.state this.toggleAction}}")